<template>
  <div class="bg-secondary pa-2">
    <div class="my-10 mx-auto">
      <SubTitle :title-name="sectionName" />
      <div
        style="line-height: 1.5em;"
        class="pa-3 ma-5 text-justify text-md-center"
      >
        <p class="ma-8 text-h5">
        令和に復活！<br/>敵は二億四千万、挑むは8匹の狼たち！！
        </p>
        <p class="ma-4">
         時代を超えてよみがえるあのRPG。<br/>
        BURAI パッケージ版は、MSX2版「BURAI上巻」「BURAI完結編」の二作品が一本に収録されています。
        </p>
        <p class="ma-4">
          40分を越えるオープニング、一癖も二癖もあるキャラクターたちによるストーリー、美麗なグラフィック、そして衝撃的なハイクオリティサウンド。<br/>
          Nintendo Switch版ではクイックセーブ・ロード、巻き戻し機能などの便利機能を搭載しました。
        </p>
      
      </div>
    </div>
  </div>
</template>
<script>
  import SubTitle from "./SubTitle.vue";

  export default {
    components: {
      SubTitle,
    },
    data() {
        return {
          sectionName: "「BURAI」とは",
        };
      },
  };
</script>
